import NewMemberQueries from './NewMemberQueries'

const mvNewMember = {
  mvNewMember: {
    ...NewMemberQueries,
  }
}

export default mvNewMember